(function () {
  if (window.location.pathname !== '/' && !document.body.classList.contains('template-index')) return;

  function getAnnHeight() {
    const ann = document.querySelector('.section-announcement-bar, [class*="announcement"]');
    return ann ? ann.offsetHeight : 0;
  }

  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeOutQuad(t) { return 1 - (1 - t) * (1 - t); }

  function init() {
    const headerEl        = document.querySelector('.xo-header');
    const headerCenter    = document.querySelector('.xo-header__center');
    const headerLeft      = document.querySelector('.xo-header__left');
    const headerRight     = document.querySelector('.xo-header__right');
    const transparentLogo = document.querySelector('.xo-header__logo-img--transparent');
    const stickyLogo      = document.querySelector('.xo-header__logo-img--sticky');

    if (transparentLogo) {
      transparentLogo.style.opacity    = '0';
      transparentLogo.style.visibility = 'hidden';
    }

    const hideEls = [headerLeft, headerRight, headerCenter];
    hideEls.forEach(el => {
      if (el) {
        el.style.opacity    = '0';
        el.style.visibility = 'hidden';
        el.style.transition = 'none';
      }
    });

    if (headerEl) {
      headerEl.style.position   = 'fixed';
      headerEl.style.top        = '0';
      headerEl.style.width      = '100%';
      headerEl.style.zIndex     = '100';
      headerEl.style.background = 'transparent';
      headerEl.style.opacity    = '0';
      headerEl.style.visibility = 'hidden';
      headerEl.style.transition = 'none';
    }

    // Morph element
    const morph = document.createElement('div');
    morph.id = 'cs-morph-logo';

    const heroSrcEl = document.getElementById('cs-hero-morph-src');
    const customSrc = heroSrcEl ? heroSrcEl.dataset.src : null;
    const isImage   = !!customSrc;

    if (isImage) {
      morph.innerHTML = `<img src="${customSrc}" alt="CarScent" style="width:100%;height:100%;object-fit:contain;display:block;image-rendering:crisp-edges;">`;
    } else {
      const shopName = document.querySelector('.xo-header__logo-heading--transparent')?.textContent?.trim() || 'CARSCENT';
      morph.textContent = shopName;
    }

    const annH     = getAnnHeight();
    const isMobile = window.innerWidth <= 749;

    // ─── INHI 2 LINES SE WIDTH AUR POSITION CONTROL KARO ───
    const BIG_W = isMobile ? window.innerWidth - 54 : Math.min(window.innerWidth * 0.88, 1100);
    const BIG_Y = isMobile ? annH + 20 : annH - 70; // desktop upar, mobile neeche
    // ────────────────────────────────────────────────────────

    const BIG_H = isImage ? BIG_W * 0.25 : BIG_W * 0.18;
    const BIG_X = isMobile ? 27 : (window.innerWidth - BIG_W) / 2;

    morph.style.cssText = `
      position: fixed;
      z-index: 9999;
      pointer-events: none;
      width: ${BIG_W}px;
      height: ${BIG_H}px;
      top: ${BIG_Y}px;
      left: ${BIG_X}px;
      will-change: width, height, top, left;
      ${!isImage ? `
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-weight: 300;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #ffffff;
        white-space: nowrap;
        line-height: 1;
        font-size: ${BIG_W * 0.13}px;
        display: flex;
        align-items: center;
        justify-content: center;
      ` : ''}
    `;
    document.body.appendChild(morph);

    function getSmallPos() {
      const rect = headerCenter?.getBoundingClientRect();
      if (rect && rect.width > 0) {
        return { x: rect.left, y: rect.top, w: rect.width, h: rect.height };
      }
      const hdrH = headerEl?.offsetHeight || 64;
      const w = stickyLogo?.offsetWidth || 100;
      const h = stickyLogo?.offsetHeight || 50;
      return {
        x: (window.innerWidth - w) / 2,
        y: annH + (hdrH - h) / 2,
        w, h
      };
    }

    let headerShown = false;

    function update() {
      const isMobileNow = window.innerWidth <= 749;
      const scrollY     = window.scrollY;
      const maxScroll   = isMobileNow ? 60 : 100;
      const raw = Math.min(scrollY / maxScroll, 1);
      const t   = easeOutQuad(raw);

      const sm = getSmallPos();

      const currentBigW = isMobileNow ? window.innerWidth - 54 : BIG_W;
      const currentBigX = isMobileNow ? 27 : BIG_X;

      const x = lerp(currentBigX, sm.x, t);
      const mobileBigY = annH + 20;
      const currentBigY = isMobileNow ? mobileBigY : BIG_Y;
      const y = lerp(currentBigY, sm.y, t);
      const w = lerp(currentBigW, sm.w, t);
      const h = lerp(BIG_H, sm.h, t);

      morph.style.width  = w + 'px';
      morph.style.height = h + 'px';
      morph.style.top    = y + 'px';
      morph.style.left   = x + 'px';

      if (!isImage) {
        const fontSize = lerp(currentBigW * 0.13, 16, t);
        morph.style.fontSize = fontSize + 'px';
        const c = Math.round(lerp(255, 0, t));
        morph.style.color = `rgb(${c},${c},${c})`;
      }

      // Header background
      if (headerEl) {
        headerEl.style.background = `rgba(255,255,255,${t})`;
        headerEl.style.boxShadow  = t > 0.1 ? `0 1px 0 rgba(0,0,0,${t * 0.08})` : 'none';
      }

      // Animation complete — sab ek saath show
      if (t >= 0.95 && !headerShown) {
        headerShown = true;
        morph.style.opacity = '0';

        if (headerEl) {
          headerEl.style.opacity    = '1';
          headerEl.style.visibility = 'visible';
          headerEl.style.background = 'rgba(255,255,255,1)';
          headerEl.style.boxShadow  = '0 1px 0 rgba(0,0,0,0.08)';
        }

        hideEls.forEach(el => {
          if (el) {
            el.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
            el.style.opacity    = '1';
            el.style.visibility = 'visible';
          }
        });

      } else if (t < 0.95 && headerShown) {
        headerShown = false;
        morph.style.opacity = '1';

        if (headerEl) {
          headerEl.style.opacity    = '0';
          headerEl.style.visibility = 'hidden';
          headerEl.style.background = 'transparent';
          headerEl.style.boxShadow  = 'none';
        }

        hideEls.forEach(el => {
          if (el) {
            el.style.transition = 'none';
            el.style.opacity    = '0';
            el.style.visibility = 'hidden';
          }
        });
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();